module.exports = __webpack_public_path__ + "static/media/addMemberGuide3.ddadfcbc.png";